const localeEn = {
  en: {
    SORT_BY: 'Sort by',
    SELECT_DOWNLOADABLE: 'Select downloadable',
    NO_RESULTS_FOUND: 'Oops, no results found',
    ALL_DOWNLOADABLE: 'All downloadable',

    HERO_TITLE: 'Downloads',
    HERO_DESCRIPTION:
      'Check out the best resources of your interest to stay trendy',

    SEO_TITLE: 'Downloads | Crehana for businesses',
    SEO_DESCRIPTION:
      "We design agile training with professionals from Google, Facebook, Amazon, and more. Improve your team's skills in design, data, digital transformation, soft skills, and more.",

    ORDER_ALL: 'All',
    ORDER_RECENT: 'Most recent',
    ORDER_POPULARITY: 'Most popular',
    ORDER_OLDER: 'Oldest',
  },
};

export default localeEn;
